/* SEW Assistant - sends chat activity to the store's own Google Sheet.
   Endpoint is set in the theme editor; if it is blank this file does nothing. */
(function () {
  'use strict';

  var URL = (window.SEW_ASSISTANT_LOG || '').trim();
  if (!URL) return;

  var LOG_KEY = 'sew_bot_analytics';
  var SENT_KEY = 'sew_bot_synced';
  var SID_KEY = 'sew_bot_session';

  function sessionId() {
    try {
      var s = localStorage.getItem(SID_KEY);
      if (!s) {
        s = Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
        localStorage.setItem(SID_KEY, s);
      }
      return s;
    } catch (e) { return 'anon'; }
  }

  function read(key, fallback) {
    try { return JSON.parse(localStorage.getItem(key) || fallback); } catch (e) { return JSON.parse(fallback); }
  }

  var busy = false;

  function sync() {
    if (busy) return;
    var all = read(LOG_KEY, '[]');
    var sent = read(SENT_KEY, '0');
    if (typeof sent !== 'number' || sent > all.length) sent = 0;

    var pending = all.slice(sent).filter(function (r) {
      return r && (r.ev === 'hit' || r.ev === 'miss' || r.ev === 'lead_captured');
    });
    if (!pending.length) {
      try { localStorage.setItem(SENT_KEY, String(all.length)); } catch (e) {}
      return;
    }

    var sid = sessionId();
    var page = location.pathname;
    var rows = pending.map(function (r) {
      r.sid = sid;
      r.page = page;
      return r;
    });

    busy = true;
    fetch(URL, {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify({ rows: rows })
    })
      .then(function () {
        try { localStorage.setItem(SENT_KEY, String(all.length)); } catch (e) {}
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  setTimeout(sync, 4000);
  setInterval(sync, 20000);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') sync();
  });
})();
